import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'VoucherInput',
  props: {
  value: {
    type: String,
    default: '',
  },
  valid: {
    type: Boolean,
    default: true,
  },
  label: {
    type: String,
    default: 'wgs.std.code',
  },
  mask: {
    type: String,
    default: 'NNN-NNN-NNN',
  },
  placeholder: {
    type: String,
    default: 'ABC-def-123',
  },
  size: {
    type: String,
    default: 'lg',
  },
  readonly: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  'input',
],
  setup(__props, { emit: emits }) {

const props = __props

const { getters } = store;
const configId = computed(() => getters.getConfigId);





const localValue = computed({
  get(): string {
    return props.value;
  },

  set(newValue: string): void {
    emits('input', newValue);
  },
});

return { __sfc: true,getters, configId, emits, props, localValue }
}

})